<template>
    <v-app>
        <timers />
        <transition name="fade">
            <sidebar
                v-if="logged && ready"
                :drawer="drawer" 
                @close-drawer="detectEvent"
                @change-mini="updateMini"
                />
        </transition>
        <transition name="fade">
            <navbar 
                v-if="logged && ready"
                :drawer="drawer" 
                @update-drawer="drawer = !drawer"
                class="d-md-none"/>
        </transition>
        <v-main>
            <transition name="fade">
                <div v-if="logged && !ready" class="load-screen d-flex">
                    <div class="ma-auto">
                        <img src="@/assets/logo.png" alt="logo" class="mb-3" height="100px">
                        <v-progress-linear
                            color="accent"
                            indeterminate
                            rounded
                        >
                        </v-progress-linear>
                    </div>
                </div>
                <router-view v-else class="container pt-12 pt-md-3" :class="{ 'offset-drawer': miniShow }" />
             </transition>
        </v-main>
    </v-app>
</template>

<script>
import { mapState } from 'vuex'
import navbar from './components/navigation/navbar'
import sidebar from './components/navigation/sidebar'
import timers from './components/timers'

export default {
    name: 'App',
    components: {
        navbar,
        sidebar,
        timers
    },
    computed:{
        ...mapState({
            logged: state => state.user.logged,
            ready: state => state.account.ready && state.gateways.ready && state.meters.ready
        })
    },
    data() {
        return {
            drawer: true,
            miniShow: null
        }
    },
    methods: {
        detectEvent(value){
            this.drawer = value
        },
        updateMini(value) {
            this.miniShow = !value
        },
    },
};
</script>

<style scope>
.container{
    background-color: var(--v-background-base);
    min-height: 100%;
    min-width: 100%;
}
.offset-drawer{
    padding-left: 310px;
}
.v-card{
    border-radius: 10px !important;
}
.load-screen{
    background-color: var(--v-background-base);
    min-height: 100%;
    min-width: 100%;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>